package uz.ferro.erp.navigator

enum class NavigationPage {
    LOGIN,
    ADMIN_HOME,
    ADMIN_USER,
    ADMIN_USER_NEW,
    ADMIN_PRODUCT,
    ADMIN_PRODUCT_NEW,
    ADMIN_EXCHANGE_RATE,
    ADMIN_SETTINGS,
    ADMIN_ORDER,
    CUSTOMER,
    USER,
    VISIT,
    TASK,
    ORDER_LIST,
    ORDER_DETAILS,
    TOP_UP,
    FAQ,
    SUPPORT
}